import * as React from 'react';

import { bemBlock } from 'af-utils/bem.util';
import type { CellWidthsMap } from 'af-utils/react.util';

import Tooltip from 'af-components/Tooltip';

import type { WorkSummaryColumnMeta } from '../values';
import { resolveStyleForColumn } from '../values';

interface OwnProps {
	additionalStyling?: { [modifier: string]: boolean; };
	cellClassName: string;
	cellTextClassName: string;
	cellWidthsMap: CellWidthsMap;
	displayValue: string | React.JSX.Element;
	column: WorkSummaryColumnMeta;
	tooltipMessage?: string | React.JSX.Element;
}

type Props = OwnProps;

const _renderContent = (displayValue: string | React.JSX.Element, tooltipMessage?: string | React.JSX.Element) => {
	if (tooltipMessage) {
		return (
			<Tooltip message={tooltipMessage}>
				{displayValue}
			</Tooltip>
		);
	}
	return displayValue;
};

const WorkSummaryDetailsTableCell: React.FC<Props> = (props) => {
	const { cellClassName, cellTextClassName, cellWidthsMap, displayValue, column, additionalStyling, tooltipMessage } = props;

	return (
		<span
			className={bemBlock(cellClassName, additionalStyling)}
			style={resolveStyleForColumn(column, cellWidthsMap)}
		>
			<span className={cellTextClassName}>
				{_renderContent(displayValue, tooltipMessage)}
			</span>
		</span>
	);
};

export default React.memo(WorkSummaryDetailsTableCell);
